<template>
  <div
    ref="table"
    class="tabulator table-bordered"
  />
</template>

<script>
import Tabulator from "tabulator-tables";
import store from "@/store/store";
var defaultFunctions = require("../CommonMethods/ps-tableMethods");
var tableEditors = require("../CommonMethods/ps-tableEditors");


const UpdateStrategy = {
    DATA: "DATA",
    REPLACE: "REPLACE"
};
export default {
    name: "PsTabulator",
    props: {
        data: {
            type: Array,
            default: () => [],
            required: true
        },
        options: {
            type: Object,
            default: () => ({}),
            required: true
        },
        integration: {
            type: Object,
            default () {
                return { updateStrategy: UpdateStrategy.DATA };
            },
            required: false
        }
    },
    data () {
        return {
            tabulatorInstance: Tabulator,
            resolvedOptions: Tabulator.Options | {}
        };
    },
    watch: {
        options: {
            handler () {
                this.updateOptions();
            },
            deep: true
        },
        data: {
            handler () {
                this.updateData();
            },
            deep: false
        }
    },
    destroyed() {

    },
    created() {
        window.Bus.$off("AddFrozen");
        window.Bus.$on("AddFrozen", (table, freeze) => {
            var layout = table.getColumnLayout();
            var columns = table.getColumns();

            layout[0].frozen = freeze;

            var newCols = [];
            for(var b = 0; b < columns.length; b++) {
                newCols.push(columns[b]._column.cellEvents);
            }

            for(var a = 0; a < layout.length; a++) {
                if(typeof(layout[a].titleFormatterParams) != "undefined" && typeof(layout[a].titleFormatterParams.tooltip) != "undefined" && typeof(layout[a].titleFormatterParams.tooltiptext) != "undefined" && layout[a].title.indexOf(" <span id='" + layout[a].titleFormatterParams.tooltip + "ToolTip' class='psTooltip'></span>") == -1) {
                    layout[a].title += " <span id='" + layout[a].titleFormatterParams.tooltip + "ToolTip' class='psTooltip'></span>";
                }
                layout[a].cellEvents = newCols[a];
                layout[a].cellClick = newCols[a].cellClick;
             }

             var newColumns = layout;
             table.setColumns(newColumns); 
             table.redraw(true);
        });
    },
    mounted () {
        this.updateOptions();
    },
    methods: {
        getInstance: function () {
            return this.tabulatorInstance;
        },
        createTable: function () {
            Tabulator.prototype.extendModule("print", "printFullscreen", {});
            Tabulator.prototype.extendModule("format", "formatters", defaultFunctions.formatter);
            Tabulator.prototype.extendModule("mutator", "mutators", defaultFunctions.mutator);
            Tabulator.prototype.extendModule("edit", "editors", tableEditors.editors)
            
            this.tabulatorInstance = new Tabulator(
                this.$refs.table,
                this.resolvedOptions
            );
        },
        updateOptions: function () {
            this.resolvedOptions = Object.assign({ data: this.data }, this.options);
            this.createTable();
        },
        updateData: function () {
            if (this.tabulatorInstance) {
                if (
                    this.integration &&
            this.integration.updateStrategy === UpdateStrategy.REPLACE
                ) {
                    this.tabulatorInstance.replaceData(this.data);
                } else {
                    this.tabulatorInstance.setData(this.data);
                }
            }
        },
        getTableHtml(headerTitle) {
            var table = this.getInstance();
            var columnLayout = table.getColumnLayout();

            var printTable = table.modules.export.genereateTable(table.options.printConfig, table.options.printStyled, table.options.printRowRange, "print");
            
            var printHTML = "<div id='p4PrintHtml'><table cellspacing='0' cellpadding='0'>" + $(printTable).html() + "</table></div>";
            printHTML += "<style type='text/css'>body {font-family: 'AvenirNext-Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif;} .headerTitle {background-color:#467fa5; font-weight:normal !important;padding-left:10px; font-size: 1.4em; color:white;text-align: left !important; } td { white-space: nowrap;padding:2px;} th { text-align:center !important; background-color: #b6c8d2; color: #003f64; height:30px !important;white-space: nowrap;}  table { overflow: visible !important; } thead { display: table-header-group !important; } tfoot { display: table-row-group !important } tbody { display: table-row-group !important } tr { page-break-inside: avoid !important }</style>";    
            
            var tree = $("<div>" + printHTML + "</div>");
            tree.find("input[type='checkbox']:checked").parent().html('true');
            tree.find("input[type='checkbox']").not(":checked").parent().html('false');
            printHTML = tree.html();

            var parsedHtml = $.parseHTML(printHTML);
            var tableElement = $(parsedHtml).find("table");
    
            var theadElement = $(parsedHtml).find("thead");
            var thElements = $(theadElement[0]).find("th");

            var totalTableWidth = columnLayout.reduce(function (accumulator, column) {
                return accumulator + column.width;
            }, 0);
            
            var maxColspan = 1;
            maxColspan = theadElement.find('tr').last().find('th').length;
           
            var tableElement = $(parsedHtml).find("table");
            tableElement[0].style.width = totalTableWidth + "px";

            $(theadElement[0]).prepend("<tr><th colspan='"+maxColspan+"' class='headerTitle'>" + headerTitle + "</th></tr>");

            return "<style type='text/css'>" + $(parsedHtml[1]).html() + "</style><div class='cell' style='width:100%;height:100%;' >" + $(parsedHtml).html() + "</div>";
        },
        // Converts the Table to print view and opens a popup 
        printTable(headerTitle){    
            var table = this.getInstance();
            var printTable = table.modules.export.genereateTable(table.options.printConfig, table.options.printStyled, table.options.printRowRange, "print");
            var printHTML = "<div id='print'><div class='header unselectable' style='width:100%;box-sizing: border-box;'>"+headerTitle+"</div><table style='width: 100%'  cellspacing='0' cellpadding='0'>" + $(printTable).html() + "</table></div>";
            var tree = $("<div>" + printHTML + "</div>");
            tree.find("input[type='checkbox']").parent("td").css('text-align', 'center');
            printHTML = tree.html();
            var printWin = window.open
            (
                "",
                "print",
                "width=" + document.body.clientWidth + ",height=" + document.body.clientHeight + ",status,scrollbars"
            + ",resizable,screenX=20,screenY=40"
            + ",left=20,top=40"
            );
            printWin.document.write("<html><head><style> th {text-align:center !important; color: #003F64; } .header {font-family: 'AvenirNext-Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif; background-color: #467fa5; padding: 5px; color: white; overflow: hidden; width: 100% !important; display: block; }</style></head><body>");
            printWin.document.write(printHTML);
            printWin.document.write("</body></html>");
            printWin.document.close();
            printWin.focus();
        },
        // Exports a table to a file. exportType values:   csv, pdf, excel, excelstyles, excelborders. 
        exportTable(headerTitle, exportType, printerSettings){
            var table = this.getInstance();
            var printTable = table.modules.export.genereateTable(table.options.printConfig, table.options.printStyled, table.options.printRowRange, "print");
            var printHTML = "<html>" +
                                    "<head><style> th {text-align:center !important; color: #003F64; } .header {font-family: 'AvenirNext-Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif; background-color: #467fa5; padding: 5px; color: white; overflow: hidden; width: 100% !important; display: block; }</style></head>" +
                                    "<body><div id='print'><div class='header unselectable' style='width:100%;box-sizing:border-box;'>"+headerTitle+"</div><table style='width: 100%'  cellspacing='0' cellpadding='0'>" + $(printTable).html() + "</table></div>" +
                                    "</body></html>";
            var tree = $("<div>" + printHTML + "</div>");
            tree.find("input[type='checkbox']").parent("td").css("text-align", "center");
            printHTML = tree.html(); 
            var printSettings={};
            if (exportType == "pdf"){

                var promises = [];
                $.each(["SiteReportFooter", "SiteReportFooterSize", "SiteReportFooterColor"], // use an array, cause otherwise we're just duplicating tons of lines of code for a one word change. 
                    function(ndx, val){
                        promises.push(
                            axios
                                .get(localConfig.apiUrl + "/Options/getOptionBySiteTag?name=" + val + "&siteTag=ALL", {})
                                .then(response => {
                                    printSettings[val] = response.data[0].value;
                                })
                                .catch(error => {
                                    console.log(error);
                                })
                        );
                    });

                try {
                    $(".overlay").show();
                    axios.all(promises).then(values => {
                        if(printSettings.SiteReportFooterSize === undefined || printSettings.SiteReportFooterSize === null) {
                            printSettings.SiteReportFooterSize = "0";
                        }
                        var htmlContent = { 
                            contentWidth: 1000, 
                            contentHeight: 1000, 
                            footerIsVisible: printSettings.SiteReportFooter === "FOOTER1", 
                            footerFileName: headerTitle + " as of " + this.$store.getters.theSessionSettings.gDate,
                            fileName: headerTitle, 
                            htmlContent: encodeURIComponent(printHTML),
                            Path: encodeURIComponent(this.$store.getters.theSessionSettings.printServiceDataPath),
                            Root: encodeURIComponent(this.$store.getters.theSessionSettings.printServiceDataRoot),
                            InternalPath: encodeURIComponent(this.$store.getters.theSessionSettings.printServiceDataInternalPath), 
                            footerColor: printSettings.SiteReportFooterColor,
                            footerSize: printSettings.SiteReportFooterSize.slice(-2) != "px" ? printSettings.SiteReportFooterSize + "px" : printSettings.SiteReportFooterSize
                        };

                        axios
                            .post(this.$store.getters.theSessionSettings.printServiceURL, htmlContent)
                            .then(response => {
                                $(".overlay").hide();
                                window.open(response.data, "_blank", "");
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    });
                } catch (err) {
                    console.log(err);
                }
            }

            if (exportType=="csv"){
                // Parse the HTML content into a DOM structure
                const filename = `${headerTitle}.csv`;
                const parser = new DOMParser();
                const doc = parser.parseFromString(printHTML, "text/html");

                // Extract data from table
                const rows = Array.from(doc.querySelectorAll("tr"));
                const data = rows.map(row => 
                    Array.from(row.querySelectorAll("td, th"), 
                        cell => cell.innerText.replace(/[^\x00-\x7F]+/g, "")
                    ));

                // Convert data to CSV format
                const csv = data.map(row => row.join(",")).join("\n");

                // Download the CSV file in UTF-8 format
                const blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
            }
            if (exportType == "excel" || exportType == "excelborder" || exportType == "excelstyle"){
                            $('#w-box').append("<div id='p4PrintHtml' style='display:none;'>" + this.getTableHtml(headerTitle) + "</div>");
                            $('#p4PrintHtml').find('th, tr, td, .icon-table').css({'font-size': '10px', 'height': 'auto !important', 'box-sizing': 'border-box'});
                            var excelJson = getExcelJSON($('#p4PrintHtml').find('table'), [], headerTitle, [], exportType.toLowerCase() == "excelborder", exportType.toLowerCase() != 'excel', false, printerSettings);
                    
                            axios
                            .post(this.$store.getters.theSessionSettings.printServiceURL.replace('PrintPDF', 'PrintExcel'),
                            excelJson,
                            {headers: {
                                    'Content-Type': 'application/json'
                                },  
                            })
                            .then(response => {
                                var sampleArr = base64ToArrayBuffer(response.data.item2);
                                saveByteArray(response.data.item1, sampleArr);
                                $(".overlay").hide();
                                $('#p4PrintHtml').remove();
                            })
                            .catch(error => {
                                console.log(error);
                            });
            }
            return printHTML;
        }
    }
};
</script>
